import {
  GET_PERMIT_TYPE_DETAILS_REQUEST,
  GET_PERMIT_TYPE_DETAILS_SUCCESS,
  GET_PERMIT_TYPE_DETAILS_ERROR,
  SET_ACTIVE_PERMIT_TYPE_DETAILS,
  SET_ACTIVE_PERMIT_TYPE_DEFAULT_VALUES,
} from '../actions/types';

const defaultState = {
  error: '',
  isLoading: false,
  activePermitTypeDetails: null,
};

/**
 * Permit type details reducer logic.
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_PERMIT_TYPE_DETAILS_REQUEST:
      return { ...state, isLoading: true };
    case SET_ACTIVE_PERMIT_TYPE_DETAILS:
      return { ...state, activePermitTypeDetails: action.payload };
    case GET_PERMIT_TYPE_DETAILS_SUCCESS:
      return { ...state, activePermitTypeDetails: action.payload, isLoading: false };
    case GET_PERMIT_TYPE_DETAILS_ERROR:
      return { ...state, error: action.payload, isLoading: false };
    case SET_ACTIVE_PERMIT_TYPE_DEFAULT_VALUES:
      return { ...state, defaultValues: action.payload };
    default:
      return state;
  }
};
